import {
   LOGIN_URL,
   LOGOUT_URL,
   GET_PROFILE_URL,
   EDIT_PROFILE_URL,
   CHANGE_PASSWORD_URL,
   OTP_VERIFICATION_URL,
   FORGOT_PASSWORD_URL,
   FORGOT_PASSWORD_RESET_URL
} from '../../Resources/Api';
import axios from "axios";

// Login
export function loginAction(values, actions, history) {

   return async (dispatch) => {
      actions.setSubmitting(true)
      dispatch({
         type: 'MESSAGE',
         payload: false
      })

      axios({
         method: 'POST',
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: LOGIN_URL,
         data: {
            email: values.UserName,
            password: values.Password
         }
      })
         .then(function (response) {
            // console.log("response", response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  localStorage.setItem('accessToken', response.data.token);
                  dispatch({
                     type: 'ACCESS_TOKEN',
                     payload: response.data.token
                  })
                  actions.setSubmitting(false)
                  dispatch({
                     type: 'MESSAGE',
                     payload: {
                        message: false,
                        string: 'admin_login',
                        msgType: 'success'
                     }
                  })
                  if (response.data.user_type === 'M') {
                     history.push('/')
                     // window.location.reload()
                  } else if (response.data.user_type === 'A') {
                     history.push('/')
                  } else if (response.data.user_type === 'U') {
                     history.push('/attendance')
                  }
               } else {
                  actions.setSubmitting(false)
                  dispatch({
                     type: 'MESSAGE',
                     payload: {
                        status: true,
                        message: "Opps! You are not authorize to login here.",
                        string: "admin_login",
                        msgType: 'error'
                     }
                  })
               }
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            error && error.response && error && error.response && error.response.status === 401 ?
               dispatch({
                  type: 'MESSAGE',
                  payload: {
                     status: true,
                     message: error.response.data.message,
                     string: "admin_login",
                     msgType: 'error'
                  }
               }) :
               dispatch({
                  type: 'MESSAGE',
                  payload: {
                     message: "Server connection failed. Ensure network connection",
                     string: "admin_login",
                     msgType: 'error',
                     status: true
                  }
               })
            console.log("error", error);
         });
   }
}



// Log out

export function logoutAction(authToken, history) {
   return async function (dispatch) {
      dispatch({
         type: 'LOADING_STATUS',
         payload: true
      })

      // console.log(authToken)

      const headers = {
         "Content-Type": "application/json",
         "Accept": "application/json",
         "Authorization": 'Bearer ' + authToken
      };
      // console.log(headers)
      axios({
         headers: headers,
         method: 'POST',
         url: LOGOUT_URL,
      })
         .then(function (response) {
            console.log("Logout", response.status)
            if (response.status === 200) {
               dispatch({
                  type: 'ACCESS_TOKEN',
                  payload: null
               })
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: false
               })
               localStorage.clear();
               history.push('/login')
               window.location.reload();
            } else {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: false
               })
               dispatch({
                  type: 'ERROR_MESSAGE',
                  payload: response.data.message
               })
            }

         })
         .catch(function (error) {
            // console.log(error.response.status);
            if (error && error.response && error.response.status === 401) {
               localStorage.clear();
               history.push('/login')
               window.location.reload();
            }
            dispatch({
               type: 'LOADING_STATUS',
               payload: false
            })
            dispatch({
               type: 'ERROR_MESSAGE',
               payload: "Server connection failed. Ensure network connection"
            })
            // console.log(error);
         });
   }
}

// Get Profile
export function getProfile(authToken) {
   return async function (dispatch) {
      // console.log(authToken)
      const headers = { Authorization: 'Bearer ' + authToken };
      axios({
         headers: headers,
         method: 'post',
         url: GET_PROFILE_URL,
         responseType: 'json'
      })
         .then(function (response) {
            // console.log('Auth Action=================', response.data.data);
            if (response.data.error === false) {
               dispatch({
                  type: 'GET_PROFILE',
                  payload: response.data.data
               })
            } else {
               dispatch({
                  type: 'ERROR_MESSAGE',
                  payload: "Server connection failed. Ensure network connection"
               })
            }
         });
   }
}

// Edit Profile
export function editProfile(name, authToken) {
   // console.log("Edit name===", name)
   return async function (dispatch) {
      dispatch({
         type: 'MULTI_LOADING_STATUS',
         payload: {
            status: true,
            data: 'edit_profile'
         }
      })
      const headers = {
         Authorization: 'Bearer ' + authToken,
         'Accept': 'application/json',
         'Content-Type': 'application/json',
      };

      // console.log(authToken)

      axios({
         headers: headers,
         method: 'post',
         url: EDIT_PROFILE_URL,
         responseType: 'json',
         data: {
            name: name
         }
      })
         .then(function (response) {
            // console.log(response.data.data);
            if (response.data.error === false) {
               dispatch({
                  type: 'GET_PROFILE',
                  payload: response.data.data
               })
               dispatch({
                  type: 'SUCCESS_MESSAGE',
                  payload: response.data.message
               })
               dispatch({
                  type: 'EDIT_PROFILE_NAME_STATUS',
                  payload: false
               })
               dispatch({
                  type: 'MULTI_LOADING_STATUS',
                  payload: {
                     status: false,
                     data: 'edit_profile'
                  }
               })
            } else {
               dispatch({
                  type: 'MULTI_LOADING_STATUS',
                  payload: {
                     status: false,
                     data: 'edit_profile'
                  }
               })
               dispatch({
                  type: 'MULTI_ERROR_MESSAGE',
                  payload: {
                     data: "edit_profile",
                     message: "Server connection failed. Ensure network connection",
                     status: true
                  }
               })
            }
         }).catch(function (error) {
            // if (error.response.status === 401) {
            //    localStorage.clear();
            //    history.push('/login')
            //    window.location.reload();
            // } 
            dispatch({
               type: 'MULTI_LOADING_STATUS',
               payload: {
                  status: false,
                  data: 'edit_profile'
               }
            })
            dispatch({
               type: 'MULTI_ERROR_MESSAGE',
               payload: {
                  data: "edit_profile",
                  message: "Server connection failed. Ensure network connection",
                  status: true
               }
            })
         })
   }
}


// Change Password

export function changePasswordAction(current_password, password, confirm_password, authToken) {
   return async (dispatch) => {
      dispatch({
         type: 'MULTI_LOADING_STATUS',
         payload: {
            status: true,
            data: 'change_password'
         }
      })

      axios({
         method: 'post',
         url: CHANGE_PASSWORD_URL,
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         data: {
            current_password: current_password,
            password: password,
            confirm_password: confirm_password,
         }
      })
         .then(function (response) {
            // console.log("Reg===", response)
            if (response.data.error === false) {
               dispatch({
                  type: 'MULTI_LOADING_STATUS',
                  payload: {
                     status: false,
                     data: 'change_password'
                  }
               })
               dispatch({
                  type: 'CHANGE_PASSWORD_BTN_STATUS',
                  payload: false
               })
               dispatch({
                  type: 'SUCCESS_MESSAGE',
                  payload: response.data.data
               })
               dispatch({
                  type: 'MULTI_ERROR_MESSAGE',
                  payload: false
               })
            } else {
               dispatch({
                  type: 'MULTI_LOADING_STATUS',
                  payload: {
                     status: false,
                     data: 'change_password'
                  }
               })
               dispatch({
                  type: 'MULTI_ERROR_MESSAGE',
                  payload: {
                     data: "password_change",
                     message: response.data.errorMessage,
                     status: true
                  }
               })
            }
         })
         .catch(function (error) {
            // if (error.response.status === 401) {
            //    localStorage.clear();
            //    history.push('/login')
            //    window.location.reload();
            // } 
            console.log(error);
            dispatch({
               type: 'MULTI_LOADING_STATUS',
               payload: {
                  status: false,
                  data: 'change_password'
               }
            })
            dispatch({
               type: 'MULTI_ERROR_MESSAGE',
               payload: {
                  data: "password_change",
                  message: "Server connection failed. Ensure network connection",
                  status: true
               }
            })
            console.log(error);
         });
   }
}

//Forgot Password

export function forgotPasswordAction(email, history) {
   return async (dispatch) => {
      dispatch({
         type: 'LOADING_STATUS',
         payload: true
      })

      axios({
         method: 'post',
         url: FORGOT_PASSWORD_URL,
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         data: {
            email: email
         }
      })
         .then(function (response) {
            // console.log("Reg===", response)
            if (response.data.error === false) {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: false
               })
               dispatch({
                  type: 'SUCCESS_MESSAGE',
                  payload: response.data.data
               })
               dispatch({
                  type: 'ERROR_MESSAGE',
                  payload: false
               })
            } else {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: false
               })
               dispatch({
                  type: 'SUCCESS_MESSAGE',
                  payload: false
               })
               dispatch({
                  type: 'ERROR_MESSAGE',
                  payload: response.data.errorMessage
               })
            }
         })
         .catch(function (error) {
            if (error.response.status === 401) {
               localStorage.clear();
               history.push('/login')
               window.location.reload();
            }
            console.log(error);
            dispatch({
               type: 'LOADING_STATUS',
               payload: false
            })
            dispatch({
               type: 'ERROR_MESSAGE',
               payload: {
                  message: "Server connection failed. Ensure network connection",
                  status: true
               }
            })
            // console.log(error);
         });
   }
}
//Forgot Password Reset

export function forgotResetAction(password, passwordConfirm, rToken, history) {
   return async (dispatch) => {
      dispatch({
         type: 'LOADING_STATUS',
         payload: true
      })

      axios({
         method: 'post',
         url: FORGOT_PASSWORD_RESET_URL,
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         data: {
            password: password,
            confirm_password: passwordConfirm,
            token: rToken,
         }
      })
         .then(function (response) {
            // console.log("Reg===", response)
            if (response.data.error === false) {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: false
               })
               dispatch({
                  type: 'SUCCESS_MESSAGE',
                  payload: response.data.data
               })
               dispatch({
                  type: 'ERROR_MESSAGE',
                  payload: false
               })
            } else {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: false
               })
               dispatch({
                  type: 'SUCCESS_MESSAGE',
                  payload: false
               })
               dispatch({
                  type: 'ERROR_MESSAGE',
                  payload: response.data.errorMessage
               })
            }
         })
         .catch(function (error) {
            if (error.response.status === 401) {
               localStorage.clear();
               history.push('/login')
               window.location.reload();
            }
            console.log(error);
            dispatch({
               type: 'LOADING_STATUS',
               payload: false
            })
            dispatch({
               type: 'ERROR_MESSAGE',
               payload: {
                  message: "Server connection failed. Ensure network connection",
                  status: true
               }
            })
            // console.log(error);
         });
   }
}


